import { Box, Button, List, ListItem, ListItemText, Divider, IconButton } from '@mui/material';
import { Add, Delete, Edit, Visibility } from '@mui/icons-material';

const LectureNotesTab = ({
  notes,
  setOpenNoteDialog,
  setIsEditingNote,
  setNewNote,
  setSelectedNote,
  handleDeleteNote,
  setOpenViewNoteDialog,
}) => {
  const handleViewNote = (note) => {
    setSelectedNote(note);
    setOpenViewNoteDialog(true);
  };

  const handleEditNote = (note) => {
    setSelectedNote(note);
    setNewNote({
      title: note.title || '',
      note_content: note.note_content || '',
      link: note.link || '',
      image: note.image || null,
    });
    setIsEditingNote(true);
    setOpenNoteDialog(true);
  };

  return (
    <Box mt={3}>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => {
          setIsEditingNote(false);
          setNewNote({ title: '', note_content: '', link: '', image: null });
          setOpenNoteDialog(true);
        }}
        sx={{ mb: 2 }}
      >
        Add Note
      </Button>
      <List>
        {notes.map((note) => (
          <Box key={note.id}>
            <ListItem>
              <ListItemText
                primary={note.title || ''}
                secondary={note.note_content ? note.note_content.substring(0, 100) + '...' : ''}
              />
              <Box>
                <IconButton onClick={() => handleViewNote(note)}>
                  <Visibility />
                </IconButton>
                <IconButton onClick={() => handleEditNote(note)}>
                  <Edit />
                </IconButton>
                <IconButton onClick={() => handleDeleteNote(note.id)}>
                  <Delete />
                </IconButton>
              </Box>
            </ListItem>
            <Divider />
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default LectureNotesTab;